import axios from "axios";

export default class CategoriasService {
  getAll(){
    return axios.get(process.env.VUE_APP_API_PUBLIC + "ciudades/all")
  }  
}
